import React from 'react'
import { MODAL_KEYS } from 'app-constants'
import { UnderstandYourBillsModal } from './understand-your-bills'
import { FileUploadModal } from './file-upload'
import { PasswordResetModal } from './password-reset'
import { UraEvaluationModal } from './ura-evaluation'
import { UpdateEmailModal } from './update-email'
import { MessagesModal } from './messages'
import { UraEvaluationValidationModal } from './ura-evaluation-validation'
import { ContactUpdateModal } from './contact-update'
import { ReferFriendModal } from './refer-friend'
import { DaysToBreachAgreementModal } from './days-to-breach-agreement'
import { ObjectionsModal } from './objection'
import { RedirectModal } from './redirect'
import { PaymentModal } from './payment-modal'
import { PixModal } from './pix'
import { CreditCardModal } from './credit-card'
import { RequiredPasswordUpdate } from './required-password-update'

export function ModalTemplate() {
  return {
    [MODAL_KEYS.UNDERSTAND_YOUR_BILLS]: <UnderstandYourBillsModal />,
    [MODAL_KEYS.FILE_UPLOAD]: <FileUploadModal />,
    [MODAL_KEYS.PASSWORD_RESET]: <PasswordResetModal />,
    [MODAL_KEYS.URA_EVALUATION_SUCESS]: <UraEvaluationModal />,
    [MODAL_KEYS.URA_EVALUATION_VALIDATION]: <UraEvaluationValidationModal />,
    [MODAL_KEYS.UPDATE_EMAIL]: <UpdateEmailModal />,
    [MODAL_KEYS.MESSAGES]: <MessagesModal />,
    [MODAL_KEYS.CONTACT_UPDATE]: <ContactUpdateModal />,
    [MODAL_KEYS.REFER_FRIEND]: <ReferFriendModal />,
    [MODAL_KEYS.DAYS_TO_BREACH_AGREEMENT]: <DaysToBreachAgreementModal />,
    [MODAL_KEYS.OBJECTIONS]: <ObjectionsModal />,
    [MODAL_KEYS.REDIRECT_LINK]: <RedirectModal />,
    [MODAL_KEYS.PAYMENT]: <PaymentModal />,
    [MODAL_KEYS.CREDIT_CARD]: <CreditCardModal />,
    [MODAL_KEYS.PIX_PAYMENT]: <PixModal />,
    [MODAL_KEYS.REQUIRED_PASSWORD_UPDATE]: <RequiredPasswordUpdate />,
  }
}
